import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Moo cards - best thing since kitten litter",
  "description": "",
  "published": "2008-11-07T00:00:00.000Z",
  "redirect_from": ["/blog/moo-cards-best-thing-since-kitten-litter/swizec/45"],
  "categories": "life, review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last week I read a `}<a parentName="p" {...{
        "href": "http://www.jurecuhalev.com/blog/2008/10/22/10-basic-tools-of-startup-social-media-presence/"
      }}>{`blog about Moo cards are by Jure Cuhalev`}</a>{` and a few days later decided to go and order a batch to see what the fuss is about. So I went to `}<a parentName="p" {...{
        "href": "http://www.moo.com/"
      }}>{`moo.com`}</a>{` and clicked around, quickly set up a profile and started designing my cards. Since over the years I managed to accumulate a large quantity of somewhat decent photographs on flickr I decided it'd be best to just import from there.`}</p>
    <p>{`The interface was `}<strong parentName="p">{`amazing`}</strong>{` very simple to use, just drag and drop images to and fro. I actually had fun designing my moo cards and that, I believe, is quite a feat of interface engineering. After this was done there was some waiting involved and two days ago the cards were waiting in my mailbox.`}</p>
    <p>{`Upon opening the package I was greeted by heaps upon heaps of branding, but it was unobtrusive and quite a joy to read. The little discount moo cards I got to disperse around are a touch of genious if you ask me. Very good way of getting new customers. Immediately, I was doing this at work, I was asked to share the love and gave my new cards out to people who were all quite amazed and found them endearing.`}</p>
    <p>{`Later, at school, I gave out more cards and everyone seemed to enjoy them and asked many questions as to where they came from. This speaks to the greatness of these moo cards (or is it the greatness of my photography?) so even though I have absolutely no idea of how actually useful moo cards might be, I guess they're good for personal branding? Anyhow, they may not be very useful, but they `}<em parentName="p">{`are`}</em>{` fun and the people you give them too will actually enjoy them, you know, unlike a business card that usually finds its way to the bin quite quickly.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      